import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/library/processes/$processId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/library/processes/$processId/canvas',
      params: { processId: params.processId },
    })
  },
})
